import React, { useState, useEffect } from 'react';

import './styles.css';
import Select from '../Select';

function SelectGroup(props) {
    const [allSelected, setAllSelected] = useState(false);

    useEffect(() => {
        if (props.devView) console.log('Markeds:', props.markeds)
    }, [props.devView, props.markeds]);

    useEffect(() => {
        if (props.devView) console.log('Hides:', props.hides)
    }, [props.devView, props.hides]);

    useEffect(() => {
        if (props.markeds.length + props.hides.length === props.children.length) setAllSelected(true)
        else setAllSelected(false)
    }, [props.markeds, props.hides, props.children])

    function changeMarked(option) {
        if (props.single) {
            props.setMarkeds([option]);
        } else {
            let auxList = props.markeds.slice();
            if (auxList.includes(option)) auxList.splice(auxList.indexOf(option), 1);
            else auxList.push(option);
            props.setMarkeds(auxList);
        }
    }

    function selectStatus(index) {
        const inCheckMode = props.checkMode & props.viewMode !== true;
        if (props.hides.includes(index)) return -1
        return (props.markeds.includes(index) | (index === -1 & allSelected)) ? (inCheckMode ? 2 : 1) : (inCheckMode ? 1 : 0)
    }

    function selectAll() {
        console.log(props.blockeds);
        if (allSelected)
            props.setMarkeds(props.blockeds);
        else {
            let auxList = [];
            for (let i = 0; i < props.children.length; i++)
                if (!props.hides.includes(i)) auxList.push(i);
            props.setMarkeds(auxList);
        }
    }

    return (
        <div className='select-group'>
            {props.devView ? (props.markeds.length !== 0 ? props.markeds : 'Sem seleção') : []}
            {
                props.showInfos ?
                    <div className='select-group-infos'>
                        <p className='tittle'><b>{props.tittle ? props.tittle : 'Lista'}</b></p>
                        <p className='counter'>{props.contMarkeds ? props.markeds.length : props.children.length} {props.itemType ? props.itemType : 'itens'}</p>
                    </div>
                    : []
            }
            <div className='select-group-list'>
                {
                    props.showSelectAll ?
                        <Select
                            single={props.single}
                            viewMode={props.viewMode}
                            checkMode={props.checkMode}
                            devView={props.devView}
                            onClick={selectAll}
                            status={selectStatus(-1)}
                        >
                            <p className='select-group-list-select-all'>Selecionar todos</p>
                        </Select>
                        : []
                }
                {
                    props.children.map((item, index) => {
                        return <Select
                            key={item.key ? item.key : (item.id ? item.id : index)}
                            index={index}
                            single={props.single}
                            blocked={props.blockeds ? props.blockeds.includes(index) : false}
                            viewMode={props.viewMode}
                            checkMode={props.checkMode}
                            devView={props.devView}
                            onClick={() => changeMarked(index)}
                            status={selectStatus(index)}
                        >
                            {item}
                        </Select>
                    })
                }
            </div>
        </div>
    )
}

export default SelectGroup;